module.exports = __webpack_public_path__ + "img/pakistan.e77b0e26.svg";